<template>
  <c-main>
    <c-row>
      <c-col md="12">
        <form @submit.prevent="submit">
          <c-panel title="Groups Settings">
            <c-form-field label="Name*">
              <c-form-input
                v-bind:autocomplete="'label'"
                v-bind:status="$v.group.key.$error ? 'danger' : ''"
                v-model="group.key"
              ></c-form-input>
              <span
                v-if="group.submitted && !$v.group.key.required"
                class="form-help u-color-danger"
              >Label is required.</span>
            </c-form-field>

            <c-form-field label="Code*">
              <c-form-input
                v-bind:autocomplete="'name'"
                v-bind:status="$v.group.value.$error ? 'danger' : ''"
                v-model="group.value"
              ></c-form-input>
              <span
                v-if="group.submitted && !$v.group.value.required"
                class="form-help u-color-danger"
              >Name is required.</span>
            </c-form-field>

            <div class="u-text-right" slot="footer">
              <c-button type="primary" smart>Save</c-button>
            </div>
          </c-panel>
          
        </form>
      </c-col>
    </c-row>
  </c-main>
</template>

<script>
import FlatPickr from "cover/vendors/flatpickr";
import { required, email, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  components: {
    [FlatPickr.name]: FlatPickr,
  },
  data() {
    return {
      group: {
        value: "",
        key: "",
        submitted: false,
      },
    };
  },
  validations: {
    group: {
      key: { required },
      value: { required }
    },
  },
  computed: {

  },
  created() {
    let _this = this;
    if (this.$route.params && this.$route.params.id) {
      this.$axios
        .get(
          _this.$cfg.API_URL + "/settings/group?_id=" + this.$route.params.id
        )
        .then((res) => {
          if (res.data.status == "ok") {
            this.group = res.data.data.group;
          }
        });
    }
  },
  methods: {
    submit: function () {
      let _this = this;
      this.group.submitted = true;
      this.$v.group.$touch();

      // if its still pending or an error is returned do not submit
      if (this.$v.group.$pending || this.$v.group.$error) return;

      const vm = this.$toast.loading("Saving...");

      vm.show();
      this.$axios
        .post(_this.$cfg.API_URL + "/settings/group", this.group)
        .then((res) => {
          if (res.data.status == "ok") {
            this.$notify({
              type: "success",
              title: "Group is saved",
              closeable: true,
              duration: 5000,
            });
            vm.hide();
            this.$router.push({ name: "Settings" });
            this.$store.dispatch('config')
          }
        })
        .catch((err) => {
          this.$notify({
            type: "danger",
            title: "Server error",
            content: "err",
            closeable: true,
            duration: 5000,
          });
          vm.hide();
        });
    },
  },
};
</script>